// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","text":"recommendations__text____gwK-i","title":"recommendations__title____2tUCO recommendations__text____gwK-i","description":"recommendations__description____1YR0B recommendations__text____gwK-i","content":"recommendations__content____v195e","tileContainer":"recommendations__tileContainer____WTjR5"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/recommendations/recommendations.css
// module id = 699
// module chunks = 0